import { IPageFilter } from "../../store/queries/page-filter.interface";
import { LookupFilters } from "./lookup.reducer";
import { itemSelector, listSelector, Qry } from "../query-facade";
import { Lookup } from "./lookup.model";
import { createSelector } from "reselect";
import { getFilterByPropertyFn, getFilterBySearchTermFn } from "../../../core/util/search-and-sort";
import { getSortByFn } from "../../../core/util/utils";
import { VasState } from "../../store/store-type";

export class LookupPageFilter implements IPageFilter<Lookup, LookupFilters> {

    constructor(protected qry: Qry) {

    }

    createSelector(itemsSelector: listSelector<Lookup>, filterSelector: itemSelector<LookupFilters>): (state: VasState) => Array<Lookup> {
        return createSelector(
            itemsSelector,
            filterSelector,
            this.qry.lookupType.entities,
            (lookups, filters, lookupTypeEntities) => {
                return lookups
                    .filter(getFilterBySearchTermFn(filters.searchTerm))
                    .filter(getFilterByPropertyFn("lookupType", filters.lookupType))
                    // sort
                    .sort(getSortByFn(filters.sortBy, filters.sortDirection, (sortBy: string, lookup: Lookup) => {
                        switch (sortBy) {
                            case "name":
                                return lookup.title;
                            case "lookupType":
                                return lookupTypeEntities[lookup.lookupType].title;
                            default:
                                return 1;
                        }
                    }));
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/lookup/lookup.page-filter.ts